module.exports = __webpack_public_path__ + "static/media/google-reviews.346ff9ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/google-reviews.svg
// module id = 77
// module chunks = 0